import { cx } from "@/utils";
import {
  Arrow,
  Content,
  DropdownMenuContentProps,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

/**
 * DropdownMenu
 * Container for the DropdownItems
 */

const DropdownMenu: React.FunctionComponent<DropdownMenuContentProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Content className={cx("dropdown-menu", styles.menu, className)} {...props}>
      {children}
      <Arrow className={styles.arrow} />
    </Content>
  );
};

export default DropdownMenu;
